import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import type { ColumnValue } from '@core/prosemirror-legacy';
import type { IconName } from '@core/user-interface-legacy';
import {
  DropdownComponent,
  DropdownItemComponent,
  DropdownWidth,
  IconComponent,
} from '@core/user-interface-legacy';

type ColumnsOption = {
  count: ColumnValue;
  icon: IconName;
  label: string;
  isSelected: boolean;
};

@Component({
  selector: 'rt-columns-menu',
  standalone: true,
  imports: [CommonModule, DropdownComponent, DropdownItemComponent, TranslatePipe, IconComponent],
  templateUrl: './columns-menu.component.html',
  styleUrls: ['./columns-menu.component.less'],
})
export class ColumnsMenuComponent {
  protected readonly DropdownWidth = DropdownWidth.Small;

  public select: (val: ColumnValue) => void;
  public close: () => void;
  public getActive: () => ColumnValue;

  protected options: ColumnsOption[] = [];

  public ngOnInit() {
    this.options = this.getOptions();
  }

  private getOptions(): ColumnsOption[] {
    return [
      {
        count: 1,
        icon: 'view-column-1',
        label: 'wysiwyg.column.1',
        isSelected: this.getActive() === 1,
      },
      {
        count: 2,
        icon: 'view-column-2',
        label: 'wysiwyg.column.2',
        isSelected: this.getActive() === 2,
      },
      {
        count: 3,
        icon: 'view-column-3',
        label: 'wysiwyg.column.3',
        isSelected: this.getActive() === 3,
      },
      {
        count: 4,
        icon: 'view-column-4',
        label: 'wysiwyg.column.4',
        isSelected: this.getActive() === 4,
      },
    ];
  }
}
